import { Grid } from '@mui/material';

// Components
import { IBookmarkCompareCompany } from 'src/model/bookmark';
import CompareCompanyBookmarkCard from 'src/features/Bookmark/CompareBookmarkList/CompareCompanyBookmarkCard';

interface IListCompareBookmarkProps {
  listBookmark: IBookmarkCompareCompany[];
}

const CompareBookmarkList = ({ listBookmark }: IListCompareBookmarkProps) => {
  return (
    <Grid container spacing={2}>
      {listBookmark.map((dataBookmark: IBookmarkCompareCompany, index) => {
        return (
          <Grid xs={12} md={6} lg={6} xl={4} key={`company-bookmark-${dataBookmark.uuid}-${index}`} item>
            <CompareCompanyBookmarkCard dataBookmark={dataBookmark} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CompareBookmarkList;
